// extracted by mini-css-extract-plugin
export default {"auth-button":"styles_auth-button__eztbX"};